import React from "react";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";

const TableActions = ({ firstButton, secondButton }) => (
  <div className="form-actions form-actions-clear">
    <SecondaryButton
      onClick={firstButton.onClick}
      disabled={firstButton.disabled}
    >
      {firstButton.label}
    </SecondaryButton>
    <SecondaryButton
      onClick={secondButton.onClick}
      disabled={secondButton.disabled}
    >
      {secondButton.label}
    </SecondaryButton>
  </div>
);

export default TableActions;
